export const JOB_TYPES = {
    APX_CALCULATE_PERFORMANCE: 'apx_calculate_performance',
    DOCUMENT_TEMPLATE_GROUP_UPLOAD: 'document_template_group_upload',
    DOCUMENT_FILE_GROUP_UPLOAD: 'document_file_group_upload',
};

export const JOB_STATUS = {
    PROCESSING: 0,
    FINISHED: 1,
    FINISHED_WITH_FAILURES: 2,
    CANCELLED: 3,
};

export const JOB_STATUS_TRANSLATIONS = {
    [JOB_STATUS.PROCESSING]: 'label_processing',
    [JOB_STATUS.FINISHED_WITH_FAILURES]: 'label_failed',
    [JOB_STATUS.FINISHED]: 'label_finished',
    [JOB_STATUS.CANCELLED]: 'label_cancelled',
};

export const PROCESSING_STATUS = {
    FAILED: -1,
    QUEUED: 0,
    PROCESSING: 1,
    SUCCESSFUL: 2,
    CANCELLED: 3,
};

export const PROCESSING_STATUS_TRANSLATIONS = {
    [PROCESSING_STATUS.FAILED]: 'label_failed',
    [PROCESSING_STATUS.QUEUED]: 'label_queued',
    [PROCESSING_STATUS.PROCESSING]: 'label_processing',
    [PROCESSING_STATUS.SUCCESSFUL]: 'label_finished',
    [PROCESSING_STATUS.CANCELLED]: 'label_cancelled',
};
